import { ReactComponent as DiscordIcon } from 'assets/images/discord.svg';
import { ReactComponent as InstagramIcon } from 'assets/images/icon-Instagram-white.svg';
import { ReactComponent as TwitterIcon } from 'assets/images/icon-Twitter-white.svg';
import { ReactComponent as YoutubeIcon } from 'assets/images/icon-YouTube-white.svg';
import { ReactComponent as TiktokIcon } from 'assets/images/tik-tok.svg';
import { FooterLinks } from 'constants/enums/FooterLinks.ts';
import { PRIVACY_POLICY, TERMS_AND_CONDITION } from 'navigation/Routes.ts';
import React from 'react';

export const footerConfig = [
	{
		name: 'X.com',
		url: FooterLinks.TWITTER,
		icon: <TwitterIcon />,
	},
	{
		name: 'Instagram',
		url: FooterLinks.INSTAGRAM,
		icon: <InstagramIcon />,
	},
	{
		name: 'Tiktok',
		url: FooterLinks.TIKTOK,
		icon: <TiktokIcon />,
	},
	{
		name: 'Youtube',
		url: FooterLinks.YOUTUBE,
		icon: <YoutubeIcon />,
	},
	{
		name: 'Discord',
		url: FooterLinks.DISCORD,
		icon: <DiscordIcon />,
	},
];

export const footerRightSectionConfig = [
	{
		header: 'Product',
		links: [
			{
				name: 'Pricing',
				url: FooterLinks.PRICING,
			},
			{
				name: 'API Documentation',
				url: FooterLinks.API_DOCUMENTATION,
			},
		],
	},
	{
		header: 'Legal',
		links: [
			{
				name: 'Privacy Policy',
				url: PRIVACY_POLICY,
			},
			{
				name: 'Terms & Conditions',
				url: TERMS_AND_CONDITION,
			},
		],
	},
];
